// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611051035/js/" + chunkId + "." + {"44":"a58ec84a","225":"9a0054e6","481":"0d7d0924","486":"f4e93d5b","770":"48c4a6d6"}[chunkId] + ".0.9194232094269574.chunk.js";
};